<template>
<div style="height: 100%;">
  <div>
    <b-container class="bv-example-row">
      <b-row class="justify-content-md-center">
        <b-col col lg="2"> Historique (jours): </b-col>
        <b-col cols="12" md="auto">
          <b-form-input v-model="periodInDays" :disabled="isLoading" type="number" style="width: 35%;"/>
        </b-col>
        <b-col col lg="2">
          <b-button @click="getData" :disabled="isLoading"><i class="fa fa-check" aria-hidden="true" /></b-button>
        </b-col>
      </b-row>
      <b-row class="justify-content-md-center">
        <b-col cols="12" md="auto">
          <b-form-group horizontal label="Filter" class="mb-0">
          <b-input-group>
              <b-form-input v-model="filter" debounce="1000"  placeholder="Rechercher" />
              <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Effacer</b-btn>
              </b-input-group-append>
          </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>
  </div>
  <div style="text-align:center; margin: 2rem;">
    <h2>
      <b>Min</b>
      <b-badge variant="success">
        {{minLeadTime}} J
      </b-badge> -
      <b>Max</b>
      <b-badge variant="danger">
        {{maxLeadTime}} J
      </b-badge> -
      <b>Moyenne</b>
      <b-badge>
        {{avgLeadTime}} J
      </b-badge>
    </h2>
  </div>
  <div style="margin-top: 3%;">
    <div v-if="isLoading">
        <i class="fa fa-spinner fa-spin fa-2x fa-fw" />
        Chargement...
    </div>
    <apexchart v-else width="95%" height="650" type="scatter" :options="chartOptions" :series="series"></apexchart>
  </div>
  <div style="margin-top: 3%;">
    <b-table
      sticky-header
      small
      id="henjuka-table"
      ref="table"
      bordered
      outlined
      :items="wrongReferences"
      responsive="md"></b-table>
  </div>
</div>
</template>

<script>
import server from '../../api/server.vue'
import Vue from 'vue'

export default {
  name: 'KanbanLTHistory',
  data: function() {
    return {
      filter: '',
      displayItems: [],
      periodInDays: 30,
      filteredItems: [],
      items: [],
      wrongReferences: [],
      minLeadTime: 0,
      maxLeadTime: 0,
      avgLeadTime: 0,
      isLoading : false,
      minDate: null,
      chartOptions: {
        dataLabels: {
          enabled: false
        },
        fill: {
          opacity: 0.8,
          gradient: {
            enabled: false
          }
        },
        title: {
          text: 'Historique des Lead Times de commandes'
        },
        xaxis: {
          type: 'datetime',
          min: 0
        },
        yaxis: {
          labels: {
            formatter: function (value) {
              return value + " j";
            }
          },
          max: 300,
          min: 0
        },
        tooltip: {
          custom: ({series, seriesIndex, dataPointIndex, w}) => {
            return '<div class="arrow_box">' +
              '<span>' + this.formatReference(this.filteredItems[dataPointIndex].reference) + '</span><br>' +
              '<span>' + this.filteredItems[dataPointIndex].designation + '</span><br>' +
              '<span>Carte n°' + this.filteredItems[dataPointIndex].card_idx + '</span><br>' +
              '<span>' + series[seriesIndex][dataPointIndex] + 'j </span><br>' +
              '<span> Lead time max: ' + (this.filteredItems[dataPointIndex].lead_time_max / (3600 * 24)).toFixed(1) + 'J</span><br>' +
              '<span> Lead time min: ' + (this.filteredItems[dataPointIndex].lead_time_min / (3600 * 24)).toFixed(1) + 'J</span>'
              '</div>'
          }
        },
        chart: {
          events: {
            markerClick: (event, chartContext, { seriesIndex, dataPointIndex, config}) => {
              this.goTo('/andon/'+this.filteredItems[dataPointIndex].reference)
            }
          }
        },
      },
      series: [{
          name: 'Réception produits',
          data: [],
        },
      ],
    }
  },
  mounted () {
    this.getData()
  },
  watch: {
    filter() {
      if (_.isEmpty(this.filter)) {
        this.filteredItems = this.items
        this.parseItemsToDataserie(this.items)
      } else {
        this.filterItems()
      }
    }
  },
  methods: {
    parseItemsToDataserie (items) {
      this.avgLeadTime = 0
      this.minLeadTime = 0
      this.maxLeadTime = 0
      this.wrongReferences = _.filter(items, (product) => (product.lead_time === null))
      items = _.filter(items, (product) => (product.lead_time != null))
      let dataSerie = []
      items.forEach((item) => {
        if (item.reference == 'EJA001D01') {
          console.log(item)
        }
        if (item.lead_time) {
          let nbDay = Math.ceil((item.lead_time / (3600 * 24)))
          if (!isNaN(nbDay) && isFinite(nbDay)) {
            dataSerie.push([item.scan_time, nbDay])
            this.avgLeadTime += nbDay
            this.maxLeadTime = Math.max(nbDay, this.maxLeadTime)
            this.minLeadTime = Math.min(nbDay, this.minLeadTime)
          }
        }
      })
      this.avgLeadTime = (this.avgLeadTime / dataSerie.length).toFixed(1)
      this.series = [{
        name: 'Réception produits',
        data: dataSerie,
      }]
    },
    getData () {
      this.isLoading = true
      const todayMs = Date.now()
      this.chartOptions = {...this.chartOptions, ...{
        xaxis: {
          type: 'datetime',
          min: todayMs - (this.periodInDays * 24 * 3600 * 1000)
        }
      }}

      server.getAllStockScansFrom(this.periodInDays).then((res) => {
        this.items = res.data
        this.parseItemsToDataserie(this.items)
      })
      .finally(() => {
        this.filteredItems = this.items
        this.isLoading = false
      })
    },
    formatReference (reference) {
      return reference.substr(0, 3) + ' ' + reference.substr(3, 3) + ' ' + reference.substr(6, 3)
    },
    filterItems() {
      this.filteredItems = _.filter(this.items, (item) => {
        return (item.reference.toUpperCase() === this.filter.toUpperCase() || item.supplier.toUpperCase() === this.filter.toUpperCase())
      })
      this.parseItemsToDataserie(this.filteredItems)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/graph/KanbanLTHistory.vue